import { Flex, Image, Button, useColorModeValue } from "@chakra-ui/react";
import { H3, Overline2 } from "src/atoms/typography";
import getIconSrc from "../icons/getIconSrcByXmppLogin";

export default function DeviceCard({
  device,
  onClick,
  buttonLabel,
  elevationLevel = 1
}) {
  const boxShadow = useColorModeValue(
    "0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06),0 4px 8px 0 rgba(0, 0, 0, 0.08)",
    "0 2px 4px -1px rgba(0, 0, 0, 0.20), 0 1px 10px 0 rgba(0, 0, 0, 0.12),0 4px 5px 0 rgba(0, 0, 0, 0.14)"
  );
  return (
    <Flex
      bg={`surfaceElevated${elevationLevel}`}
      mb="24px"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="start"
      width="320px"
      minHeight="138px"
      padding="24px"
      borderRadius="12px"
      boxShadow={boxShadow}
      position="relative"
    >
      <div>
        {device.familyName && (
          <Overline2
            color="lowEmphasis"
            mb="4px"
            whiteSpace="nowrap"
            maxWidth="200px"
            textTransform="uppercase"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {device.familyName}
          </Overline2>
        )}
        <H3
          color="highEmphasis"
          maxWidth="195px"
          overflow="hidden"
          textOverflow="ellipsis"
          display="-webkit-box"
          wordBreak="break-all"
          sx={{
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            wordWrap: "break-word"
          }}
        >
          {device.name}
        </H3>
      </div>
      <Button
        variant="containedPrimary"
        mt="18px"
        onClick={onClick}
        minWidth="80px"
      >
        {buttonLabel}
      </Button>
      <Image
        position="absolute"
        borderRadius="12px"
        height="100%"
        right="0"
        bottom="0"
        src={getIconSrc(device.jid)}
      />
    </Flex>
  );
}
